var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.2C1 3.7487 1 2.52304 1.80912 1.76152C2.61824 1 3.92049 1 6.525 1H7.02727C9.14706 1 10.2069 1 10.943 1.51859C11.1539 1.66718 11.3411 1.84339 11.499 2.04188C12.05 2.73464 12.05 3.73218 12.05 5.72727V7.38182C12.05 9.30788 12.05 10.2709 11.7452 11.0401C11.2552 12.2766 10.2189 13.2519 8.90507 13.7131C8.08784 14 7.06462 14 5.01818 14C3.84879 14 3.26409 14 2.79711 13.8361C2.04636 13.5725 1.45419 13.0152 1.17418 12.3086C1 11.8691 1 11.3188 1 10.2182V6.2Z",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0503 7.5C12.0503 8.69662 11.0802 9.66667 9.88363 9.66667C9.45087 9.66667 8.94067 9.59084 8.51991 9.70358C8.14606 9.80375 7.85405 10.0958 7.75387 10.4696C7.64113 10.8904 7.71696 11.4006 7.71696 11.8333C7.71696 13.03 6.74691 14 5.55029 14",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92529 4.25H8.47529",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92529 6.85059H5.87529",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIconActive);
export default __webpack_public_path__ + "static/media/accountsIcon-active.53cdbd0ca5a5c9d15b5a47d7192d26da.svg";
export { ForwardRef as ReactComponent };